<template>
  <div class="main card">
    <draggable :group="{ name: 'headline', put: false }" :list="items" :swapThreshold="1" :animation="200" direction="vertical">
      <div v-for="(item, index) in items" :key="index" class="item">
        <div class="header" v-b-toggle="'collapse' + index" @mouseenter="activeIndex = index" @click="setActiveIndex(item, index)">
          <div class="order">{{ index + 1 }}</div>
          <div class="detail">
            <div class="title">{{ item.title }}</div>
            <div class="option">
              <div v-if="item.displayType === 1" class="draft">پیش نویس</div>
              <div v-if="item.displayType === 2" class="public">پابلیک</div>
              <div v-if="item.displayType === 3" class="soon">به زودی</div>
              <i :class="`fa-solid fa-chevron-${activeIndex === index && arrow ? 'up' : 'down'} arrow`"></i>
              <img class="move" src="../../../assets/images/dadbanan/move.svg" />
            </div>
          </div>
        </div>
        <b-collapse :id="'collapse' + index" class="content-list">
          <div class="list">
            <draggable :list="item.sessionFiles" :group="{ name: 'headline' }" :animation="200" :swapThreshold="1" direction="vertical">
              <div v-for="(act, i) in item.sessionFiles" :key="i + 'a'" class="activity-list" @click="setActiveFile(item.id, act)">
                <img class="more" src="../../../assets/images/dadbanan/more.svg" />
                <img class="icon" :src="require(`../../../assets/images/dadbanan/r${getFileIcon(act.fileType)}.svg`)" />
                <span>{{ act.title }}</span>
              </div>
            </draggable>
          </div>
          <div class="add-activity" @click="addActivity(item.id)">
            <img src="../../../assets/images/dadbanan/add-activity.svg" />
            <span>افزودن فعالیت</span>
          </div>
        </b-collapse>
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import moocCourseSessionProvider from '../../../services/mooc/healline'

export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeIndex: '',
      arrow: false,
      items: [],
      sort: false,
    }
  },
  watch: {
    orders(c) {
      setTimeout(() => {
        if (!this.sort) {
          moocCourseSessionProvider.updateCourseHeadlineOrder(c)
        }
      }, 2000)
    },
    list() {
      this.items = this.list
    },
    items(c) {
      c.forEach((item) => {
        if (!item.sessionFiles) {
          this.$emit('update')
        }
      })
    },
  },
  computed: {
    orders() {
      let orders = []
      this.items.forEach((item, index) => {
        const head = { sessionId: item.id, order: index, sessionFiles: [] }
        item.sessionFiles.forEach((file, i) => {
          head.sessionFiles.push({ courseSessionFileId: file.id, order: i })
        })
        orders.push(head)
      })
      return orders
    },
  },
  mounted() {
    this.items = [...this.$store.state.headlines.items].sort((a, b) => a.order - b.order)
  },
  methods: {
    setActiveIndex(item, index) {
      this.activeIndex = index
      this.arrow = !this.arrow
      if (+this.$route.query.id !== +item.id) {
        this.$router.push({
          query: {
            ...this.$route.query,
            id: item.id,
          },
        })
      }
      this.$store.commit('headlines/SET_HEAD_LINE_FORM', true)
      this.$store.commit('headlines/SET_FILE_FORM', false)
      this.$store.commit('headlines/SET_FILE_CARD', false)
    },
    getFileIcon(id) {
      let i = ''
      switch (id) {
        case 0:
          i = 'video'
          break
        case 1:
          i = 'pdf'
          break
        case 2:
          i = 'file'
          break
        case 3:
          i = 'link'
          break
        case 4:
          i = 'online'
          break
        case 5:
          i = 'train'
          break
        case 6:
          i = 'exam'
          break
        case 7:
          i = 'survey'
          break
      }
      return i
    },
    addActivity(id) {
      this.$router.push({
        query: {
          id: id,
          new: true,
        },
      })
      this.$store.commit('headlines/SET_FILE_CARD', true)
      this.$store.commit('headlines/SET_HEAD_LINE_FORM', false)
      this.$store.commit('headlines/SET_FILE_FORM', false)
      this.$store.commit('headlines/SET_ISUPDATE', false)
    },
    setActiveFile(headlineId, file) {
      this.$store.commit('headlines/SET_ISUPDATE', true)
      if (typeof file.id === 'number') {
        this.$router.push({
          query: {
            ...this.$route.query,
            id: headlineId,
            fileId: file.id,
            act: this.getFileIcon(file.fileType),
          },
        })
        this.$store.commit('headlines/SET_FILE_FORM', true)
        this.$store.commit('headlines/SET_HEAD_LINE_FORM', false)
        this.$store.commit('headlines/SET_FILE_CARD', false)
      }
    },
  },
  components: { draggable },
}
</script>
Dragable

<style lang="scss" scoped>
.main {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;
  height: 600px;
  overflow-y: auto;
}

.item {
  margin-bottom: 20px;
  cursor: pointer;
}

.header {
  display: flex;
  background: #eff2f7;
  max-height: 46px;
}

.order {
  background: #556ee6;
  color: #fff;
  font-weight: 400;
  font-size: 20px;
  line-height: 33px;
  display: grid;
  place-items: center;
  width: 50px;
}

.detail {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.title {
  font-weight: 400;
  font-size: 15px;
  line-height: 25px;
  color: #000000;
  margin: 10px 20px 20px 5px;
  position: relative;
  top: 5px;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-height: 16px;
  max-height: 32px;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.option {
  display: flex;
}

.public {
  background: #ffffff;
  border: 1px solid #34c38f;
  color: #34c38f;
  border-radius: 100px;
  padding: 0 9px;
  display: grid;
  place-items: center;
  margin: 10px 0;
  height: 24px;
  min-width: 75px;
  font-size: 12px;
}

.draft {
  @extend .public;
  min-width: 80px;
  border: 1px solid #556ee6;
  color: #556ee6;
}

.soon {
  @extend .public;
  border: 1px solid #f1b44c;
  color: #f1b44c;
}

.arrow {
  padding: 14px 21px 20px 12px;
  border-left: 1px solid #ced4da;
  fill: #4e4e56;
}

.move {
  padding: 14px 10px 12px 10px;
}

.content-list {
  transition: 0.3s ease-in;
  border: 1px solid #e0e0e0;
  box-shadow: 0px 12px 24px rgba(18, 38, 63, 0.0313726);
  border-top: none;

  .add-activity {
    display: flex;
    padding: 20px;
    span {
      font-size: 12px;
      line-height: 15px;
      position: relative;
      top: 3px;
      color: #556ee6;
      margin-right: 10px;
    }
  }
}

.list {
  display: flex;
  flex-direction: column;
  padding: 20px 0;
}

.activity-list {
  display: flex;
  padding: 10px 20px;
  &:hover {
    background: #f6f6f6;
    .more {
      opacity: 1;
    }
  }
  // margin-bottom: 10px;
  .icon {
    width: 20px;
    height: 20px;
    margin-left: 12px;
  }
  .more {
    height: 13px;
    position: relative;
    right: -11px;
    top: 4px;
    opacity: 0;
  }
  span {
    font-weight: 400;
    font-size: 13px;
    line-height: 15px;
    color: #4e4e56;
  }
}
</style>
